import { fetchWrapper, handleResponse, hcUrl, buildOpts } from 'services/RequestService/helpers';

export const getOptIns = async () => {
  const response = await fetchWrapper(hcUrl('/opt_ins'), buildOpts());

  return handleResponse(response);
};
